<template>
  <Drawer
    title="新增用户"
    v-model="addStatus"
    width="300"
    :mask-closable="false"
    :closable="false"
    :styles="drawerStyles"
  >
    <Form :model="form" ref="fromRef" :rules="rules" :label-width="80" inline>
      <FormItem label="用户名" prop="name">
        <Input v-model="form.name" :maxlength="50" />
      </FormItem>
      <FormItem label="手机" prop="mobile">
        <Input v-model="form.mobile" :maxlength="11"/>
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model="form.email" :maxlength="64"/>
      </FormItem>
    </Form>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="cancel">取消</Button>
      <Button type="primary" :loading="submitLoading" @click="ok">确定</Button>
    </div>
  </Drawer>
</template>

<script>
  import V from '@/common/js/ValidatorFactory'

  export default {
    name: 'AddUser',
    data () {
      return {
        addStatus: false,
        form: {
          name: '',
          mobile: '',
          email: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: V.mobile() }
          ],
          email: [
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { validator: V.email() }
          ]
        }
      }
    },
    methods: {
      cancel () {
        this.addStatus = false
        this.$refs['fromRef'].resetFields()
      },
      async ok () {
        let v = await this.$refs['fromRef'].validate(v => v)
        v && this.doPost()
      },
      async doPost () {
        this.submitLoading = true
        let { succ = false } = await this.$http.addUser(this.form)
        this.submitLoading = false
        this.$emit('add-user', succ)
      }
    }
  }
</script>

<style scoped lang="less">
  .drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
</style>
